<template>
  <!--
      作者：kmdshop
      修改时间：2024-03-15
      描述：车辆风险管控-编辑风险
    -->
  <el-dialog
    title="编辑风险管控"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="900px"
  >
    <div class="risk-edit">
      <el-form 
        size="small" 
        :model="form" 
        ref="form" 
        :rules="rules" 
        label-width="120px"
        label-position="top"
      >
        <!-- 基础信息 -->
        <el-card class="box-card mb20" shadow="never">
          <div slot="header" class="clearfix">
            <span class="card-title">基础信息</span>
          </div>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="风险名称" prop="name" required>
                <el-input 
                  v-model="form.name" 
                  placeholder="请输入风险名称，如：G50高速长下坡制动过热风险" 
                  maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :span="6">
              <el-form-item label="年份" prop="year" required>
                <el-date-picker
                  v-model="form.year"
                  type="year"
                  placeholder="选择年份"
                  format="yyyy"
                  value-format="yyyy"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="责任部门" prop="ma_depart_id">
                <el-select 
                  v-model="form.ma_depart_id" 
                  placeholder="请选择责任部门"
                  style="width: 100%;"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="dept in departList"
                    :key="dept.ma_depart_id"
                    :label="dept.name"
                    :value="dept.ma_depart_id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="主要负责人" prop="ma_yg_id">
                <el-select 
                  v-model="form.ma_yg_id" 
                  placeholder="请选择负责人"
                  style="width: 100%;"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="user in ygList"
                    :key="user.ma_yg_id"
                    :label="user.name"
                    :value="user.ma_yg_id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>

        <!-- 风险描述 -->
        <el-card class="box-card mb20" shadow="never">
          <div slot="header" class="clearfix">
            <span class="card-title">风险评价</span>
          </div>
          
          <el-form-item label="辨识范围" prop="bs_con" required>
            <el-input
              type="textarea"
              :rows="3"
              v-model="form.bs_con"
              placeholder="描述涉及哪类车辆/人员？如：所有途经该路段的重型货运车辆及驾驶员"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="事故类型" prop="risk_type_id" required>
            <el-select
              v-model="form.risk_type_id"
              placeholder="请选择事故类型"
              multiple
              style="width: 100%;"
              clearable
              filterable
            >
              <el-option
                v-for="item in accidentTypeList"
                :key="item.risk_type_id"
                :label="item.name"
                :value="String(item.risk_type_id)"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="风险描述" prop="fx_con" required>
            <el-input
              type="textarea"
              :rows="3"
              v-model="form.fx_con"
              placeholder="描述具体操作风险？如：驾驶员未使用低速挡进行发动机制动，长时间踩刹车导致制动失效"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-card>

        <!-- 详细清单（动态表格） -->
        <el-card class="box-card mb20" shadow="never">
          <div slot="header" class="clearfix">
            <span class="card-title">风险详细清单</span>
            <el-button 
              type="primary" 
              size="mini" 
              @click="addRiskItem" 
              style="float:right;"
              icon="el-icon-plus"
            >
              添加行
            </el-button>
          </div>
          
          <el-table 
            :data="form.riskItems" 
            border 
            size="small"
            class="risk-detail-table"
            empty-text="暂无数据，请点击'添加行'按钮"
          >
            <el-table-column prop="risk_scope_identify_id" label="识别范围" width="150">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.risk_scope_identify_id"
                  placeholder="请选择识别范围"
                  style="width: 100%;"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="type in scopeIdentifyList"
                    :key="type.risk_scope_identify_id"
                    :label="type.name"
                    :value="type.risk_scope_identify_id"
                  />
                </el-select>
              </template>
            </el-table-column>
            
            <el-table-column prop="risk_target" label="风险路段/个体" width="200">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row.risk_target" 
                  placeholder="如：G50 K1250-K1260段 或 车牌：沪A12345"
                  size="small"
                ></el-input>
              </template>
            </el-table-column>
            
            <el-table-column prop="description" label="详细描述">
              <template slot-scope="scope">
                <el-input 
                  v-model="scope.row.description" 
                  placeholder="详细描述风险点，如：轮胎磨损已达临界值"
                  size="small"
                ></el-input>
              </template>
            </el-table-column>
            
            <el-table-column label="操作" width="80" align="center">
              <template slot-scope="scope">
                <el-button 
                  type="danger" 
                  icon="el-icon-delete" 
                  circle 
                  size="mini"
                  @click="removeRiskItem(scope.$index)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        
        <!-- 提交按钮 -->
        <div class="form-footer">
          <el-button @click="cancelFunc" size="medium">取消</el-button>
          <el-button 
            type="primary" 
            @click="onSubmit" 
            :loading="loading" 
            size="medium"
          >
            保存修改
          </el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import Risk_controlApi from '@/api/risk_control.js';
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    draggable,
    Uediter
  },
  data() {
    return {
      scopeIdentifyList: [],
      departList: [],
      ygList: [],
      accidentTypeList: [],
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      draftLoading: false,
      /*form表单数据*/
      form: {
        name: '',
        year: new Date().getFullYear().toString(),
        ma_depart_id: '',
        ma_yg_id: '',
        bs_con: '',
        risk_type_id: [],
        fx_con: '',
        riskItems: [],  // 这里将存储control_detail数据
        attachments: [],
        status: 'identifying'
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [
          { required: true, message: '请输入风险名称', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        year: [
          { required: true, message: '请选择年份', trigger: 'change' }
        ],
        ma_depart_id: [
          { required: true, message: '请输入责任部门', trigger: 'blur' }
        ],
        ma_yg_id: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        bs_con: [
          { required: true, message: '请输入辨识范围', trigger: 'blur' }
        ],
        risk_type_id: [
          { type: 'array', required: true, message: '请至少选择一种事故类型', trigger: 'change' }
        ],
        fx_con: [
          { required: true, message: '请输入风险描述', trigger: 'blur' }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          // 只能选择当前及之前年份，未来年份不可选
          const currentYear = new Date().getFullYear();
          return time.getFullYear() > currentYear;
        }
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.loadOrganization();
    this.loadYgList();
    this.loadTypeList();
    this.loadScopeList();
    this.dialogVisible = this.open_add;
    if (this.risk_control_id) {
      this.getDetail();
    }
  },
  props: ["open_add", "risk_control_id"],
  methods: {
    async loadYgList() {
      const response = await AfuncApi.call({
        model: 'ma_yg',
        action: 'getList'
      });
      if (response.code === 1 && response.data.list.data) {
        this.ygList = response.data.list.data || [];
      }
    },
    async loadScopeList() {
      const response = await AfuncApi.call({
        model: 'risk_scope_identify',
        action: 'getList'
      });
      if (response.code === 1 && response.data.list.data) {
        this.scopeIdentifyList = response.data.list.data || [];
      }
    },
    
    async loadTypeList() {
      const response = await AfuncApi.call({
        model: 'risk_type',
        action: 'getList'
      });
      if (response.code === 1 && response.data.list.data) {
        this.accidentTypeList = response.data.list.data || [];
      }
    },
    async loadOrganization() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_depart',
          action: 'index',
        });
        
        if (!response) {
          this.$message.warning('组织列表接口返回为空');
          this.departList = [];
          return;
        }
        
        if (response.code === 1 && response.data.list.data) {
          this.departList = response.data.list.data || [];
        } else {
          this.$message.warning('获取组织列表失败：' + (response.msg || '未知错误'));
          this.departList = [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.$message.error('加载组织列表失败，请稍后重试');
        this.departList = [];
      }
    },
    
    // 添加风险项
    addRiskItem() {
      this.form.riskItems.push({
        risk_scope_identify_id: '',
        risk_target: '',  // 注意这里改成risk_target，和接口返回一致
        description: ''
      });
    },
    
    // 删除风险项
    removeRiskItem(index) {
      this.form.riskItems.splice(index, 1);
    },
    
    // 附件处理
    handlePreview(file) {
      window.open(file.url);
    },
    
    handleRemove(file, fileList) {
      this.form.attachments = fileList;
    },
    
    handleSuccess(response, file, fileList) {
      this.form.attachments = fileList;
    },
    
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    
    // 获取详情 - 重点修改部分
    getDetail() {
      let self = this;
      Risk_controlApi.detail({ risk_control_id: self.risk_control_id }, true)
        .then(res => {
          // 转换数据结构
          const data = res.data;
          console.log('获取的详情数据:', data); // 调试用
          
          // 处理风险类型ID
          let riskTypeIds = [];
          if (data.risk_type_id) {
            if (typeof data.risk_type_id === 'string') {
              // 如果是逗号分隔的字符串，转换为数组
              riskTypeIds = data.risk_type_id.split(',').map(id => id.trim());
            } else if (Array.isArray(data.risk_type_id)) {
              riskTypeIds = data.risk_type_id;
            }
          }
          
          // 处理control_detail数据 - 这是关键修改
          let riskItems = [];
          if (data.control_detail && Array.isArray(data.control_detail)) {
            riskItems = data.control_detail.map(item => ({
              risk_control_detail_id: item.risk_control_detail_id, // 保存原始ID，用于更新
              risk_scope_identify_id: item.risk_scope_identify_id || '',
              risk_target: item.risk_target || '',  // 注意字段名是risk_target
              description: item.description || ''
            }));
          }
          
          self.form = {
            name: data.name || '',
            year: data.year || new Date().getFullYear().toString(),
            ma_depart_id: data.ma_depart_id || '',
            ma_yg_id: data.ma_yg_id || '',
            bs_con: data.bs_con || '',
            risk_type_id: riskTypeIds,
            fx_con: data.fx_con || '',
            riskItems: riskItems,  // 这里赋值为control_detail转换后的数据
            attachments: data.attachments || [],
            status: data.status || 'identifying',
            sort: data.sort || 50  // 添加sort字段
          };
        })
        .catch(error => {
          console.error('获取详情失败:', error);
          self.$message.error('获取风险详情失败');
        });
    },
    chooseCategory() {
      this.iscategorya = true;
    },
    
    openUpload(e) {
      this.isupload = true;
    },
    
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    cancelFunc() {
      this.dialogFormVisible("error");
    },
    
    // 提交表单 - 也需要相应修改
    onSubmit() {
      let self = this;
      let form = self.form;
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          
          // 准备主表数据
          const mainData = {
            risk_control_id: self.risk_control_id,
            name: form.name,
            year: form.year,
            ma_depart_id: form.ma_depart_id,
            ma_yg_id: form.ma_yg_id,
            bs_con: form.bs_con,
            risk_type_id: Array.isArray(form.risk_type_id) ? form.risk_type_id.join(',') : form.risk_type_id,
            fx_con: form.fx_con,
            status: form.status,
            sort: form.sort || 50
          };
          
          // 先更新主表
          Risk_controlApi.edit(mainData, true)
            .then(data => {
              // 处理风险详细清单
              if (form.riskItems && form.riskItems.length > 0) {
                const detailData = form.riskItems.map(item => ({
                  risk_control_detail_id: item.risk_control_detail_id, // 如果有ID就是更新，没有就是新增
                  risk_control_id: self.risk_control_id,
                  risk_scope_identify_id: item.risk_scope_identify_id,
                  risk_target: item.risk_target,  // 注意字段名改为risk_target
                  description: item.description
                }));
                
                // 调用保存详情的API - 这里需要根据你的后端API调整
                return Risk_controlApi.saveDetails(detailData);
              }
            })
            .then(() => {
              self.loading = false;
              self.$message({
                message: '修改成功',
                type: 'success'
              });
              self.dialogFormVisible("error");
              self.$emit('refresh');
            })
            .catch(error => {
              self.loading = false;
              console.error('修改失败:', error);
              self.$message.error('修改失败: ' + (error.msg || '未知错误'));
            });
        } else {
          self.$message.warning('请填写完整表单信息');
        }
      });
    },
    
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },
    
    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if (this.code == 'album') {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });
          
          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }
          
          let imgs = this.form.attachments.concat(e);
          this.$set(this.form, "attachments", imgs);
        }
      }
      this.isProductUpload = false;
    },
    
    /*删除业务附件*/
    deleteImg(index, code) {
      if (code == 'album') {
        this.form.attachments.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.mb20 {
  margin-bottom: 20px;
}

.form-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.risk-detail-table {
  margin-bottom: 20px;
}

.card-title {
  font-weight: bold;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/risk_control/index/part/edit.vue